

export class SOPutViewGrant {

  constructor(
    public uid: string,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutViewGrant(
      'uid' in params ? params.uid : null,
    );
  }
}
